import * as React from "react";

import { OwnerProfile } from "@clockwise/web-commons/src/ui/scheduling-link";

import { Banner } from "@clockwise/web-commons/src/ui/scheduling-confirmation";
import { SignupBanner } from "./signup-banner";

// util
import { getServerUrl } from "@clockwise/web-commons/src/util/post-message-common.util";
import { LinkSchedulerConfirmationSignupBannerVariant } from "@clockwise/web-commons/src/util/experiment.util";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";
import { logger } from "@clockwise/client-commons/src/util/logger";

// constants
import { paths } from "@clockwise/client-commons/src/constants/site";

export interface IProps {
  ownerProfile: OwnerProfile;
  isAuthenticatedUser: boolean;
}

export default function BannerVariants(props: IProps) {
  const { ownerProfile, isAuthenticatedUser } = props;

  const bannerBucket = isAuthenticatedUser
    ? LinkSchedulerConfirmationSignupBannerVariant.Control
    : LinkSchedulerConfirmationSignupBannerVariant.GoogleAuth;

  if (bannerBucket === LinkSchedulerConfirmationSignupBannerVariant.Control) {
    track(TrackingEvents.LINKS.CONFIRMATION_PAGE.VARIANT_CONTROL_VIEW, { isAuthenticatedUser });

    const ctaLink = `${getServerUrl()}${
      paths.scheduling
    }?utm_medium=clockwise_links&utm_source=referral&utm_campaign=links_confirmation_page`;

    return (
      <Banner
        message={
          ownerProfile.givenName
            ? `${ownerProfile.givenName} uses Clockwise to create more time each day`
            : "Clockwise helps make time for what matters"
        }
        ctaLink={
          <a
            href={ctaLink}
            target="_blank"
            cw-id="booking-learn-more"
            onClick={() =>
              track(TrackingEvents.LINKS.CONFIRMATION_PAGE.VARIANT_CONTROL_CLICKED, {
                isAuthenticatedUser,
              })
            }
          >
            Learn more
          </a>
        }
      />
    );
  } else if (bannerBucket === LinkSchedulerConfirmationSignupBannerVariant.GoogleAuth) {
    return <SignupBanner />;
  } else {
    logger.error(
      `experiment variant: ${bannerBucket} does not exist on LinkSchedulerConfirmationSignupBannerVariant`,
    );
    return <></>;
  }
}
